import PropTypes from "prop-types";
import React from "react";
import Slider from "react-slick";

class MediaAlbum extends React.Component {
  render() {
    const slideSettings = {
      speed: 60000,
      autoplay: true,
      autoplaySpeed: 1000,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      appendArrows: false
    };

    return (
      <Slider {...slideSettings}>
        {this.props.media.map(function(subattachment, index) {
          return (
            <div key={index}>
              <img src={subattachment.media.image.src} alt="" />
            </div>
          );
        })}
      </Slider>
    );
  }
}

MediaAlbum.propTypes = {
  media: PropTypes.array
};

export default MediaAlbum;
